export const SINO_NUM_0_10 = [
    { id: "Sino_Num_0", korean: '영', romanization: 'yeong', english: '0' },
    { id: "Sino_Num_1", korean: '일', romanization: 'il', english: '1' },
    { id: "Sino_Num_2", korean: '이', romanization: 'i', english: '2' },
    { id: "Sino_Num_3", korean: '삼', romanization: 'sam', english: '3' },
    { id: "Sino_Num_4", korean: '사', romanization: 'sa', english: '4' },
    { id: "Sino_Num_5", korean: '오', romanization: 'o', english: '5' },
    { id: "Sino_Num_6", korean: '육', romanization: 'yuk', english: '6' },
    { id: "Sino_Num_7", korean: '칠', romanization: 'chil', english: '7' },
    { id: "Sino_Num_8", korean: '팔', romanization: 'pal', english: '8' },
    { id: "Sino_Num_9", korean: '구', romanization: 'gu', english: '9' },
    { id: "Sino_Num_10", korean: '십', romanization: 'sip', english: '10' },
];

export const SINO_NUM_11_19 = [
    { id: "Sino_Num_11", korean: '십일', romanization: 'sip-il', english: '11' },
    { id: "Sino_Num_12", korean: '십이', romanization: 'sip-i', english: '12' },
    { id: "Sino_Num_13", korean: '십삼', romanization: 'sip-sam', english: '13' },
    { id: "Sino_Num_14", korean: '십사', romanization: 'sip-sa', english: '14' },
    { id: "Sino_Num_15", korean: '십오', romanization: 'sip-o', english: '15' },
    { id: "Sino_Num_16", korean: '십육', romanization: 'sip-yuk', english: '16' },
    { id: "Sino_Num_17", korean: '십칠', romanization: 'sip-chil', english: '17' },
    { id: "Sino_Num_18", korean: '십팔', romanization: 'sip-pal', english: '18' },
    { id: "Sino_Num_19", korean: '십구', romanization: 'sip-gu', english: '19' },
];

export const SINO_NUM_20_29 = [
    { id: "Sino_Num_20", korean: '이십', romanization: 'i-sip', english: '20' },
    { id: "Sino_Num_21", korean: '이십일', romanization: 'i-sip-il', english: '21' },
    { id: "Sino_Num_22", korean: '이십이', romanization: 'i-sip-i', english: '22' },
    { id: "Sino_Num_23", korean: '이십삼', romanization: 'i-sip-sam', english: '23' },
    { id: "Sino_Num_24", korean: '이십사', romanization: 'i-sip-sa', english: '24' },
    { id: "Sino_Num_25", korean: '이십오', romanization: 'i-sip-o', english: '25' },
    { id: "Sino_Num_26", korean: '이십육', romanization: 'i-sip-yuk', english: '26' },
    { id: "Sino_Num_27", korean: '이십칠', romanization: 'i-sip-chil', english: '27' },
    { id: "Sino_Num_28", korean: '이십팔', romanization: 'i-sip-pal', english: '28' },
    { id: "Sino_Num_29", korean: '이십구', romanization: 'i-sip-gu', english: '29' },
];

export const SINO_NUM_30_39 = [
    { id: "Sino_Num_30", korean: '삼십', romanization: 'sam-sip', english: '30' },
    { id: "Sino_Num_31", korean: '삼십일', romanization: 'sam-sip-il', english: '31' },
    { id: "Sino_Num_32", korean: '삼십이', romanization: 'sam-sip-i', english: '32' },
    { id: "Sino_Num_33", korean: '삼십삼', romanization: 'sam-sip-sam', english: '33' },
    { id: "Sino_Num_34", korean: '삼십사', romanization: 'sam-sip-sa', english: '34' },
    { id: "Sino_Num_35", korean: '삼십오', romanization: 'sam-sip-o', english: '35' },
    { id: "Sino_Num_36", korean: '삼십육', romanization: 'sam-sip-yuk', english: '36' },
    { id: "Sino_Num_37", korean: '삼십칠', romanization: 'sam-sip-chil', english: '37' },
    { id: "Sino_Num_38", korean: '삼십팔', romanization: 'sam-sip-pal', english: '38' },
    { id: "Sino_Num_39", korean: '삼십구', romanization: 'sam-sip-gu', english: '39' },
];

export const SINO_NUM_40_49 = [
    { id: "Sino_Num_40", korean: '사십', romanization: 'sa-sip', english: '40' },
    { id: "Sino_Num_41", korean: '사십일', romanization: 'sa-sip-il', english: '41' },
    { id: "Sino_Num_42", korean: '사십이', romanization: 'sa-sip-i', english: '42' },
    { id: "Sino_Num_43", korean: '사십삼', romanization: 'sa-sip-sam', english: '43' },
    { id: "Sino_Num_44", korean: '사십사', romanization: 'sa-sip-sa', english: '44' },
    { id: "Sino_Num_45", korean: '사십오', romanization: 'sa-sip-o', english: '45' },
    { id: "Sino_Num_46", korean: '사십육', romanization: 'sa-sip-yuk', english: '46' },
    { id: "Sino_Num_47", korean: '사십칠', romanization: 'sa-sip-chil', english: '47' },
    { id: "Sino_Num_48", korean: '사십팔', romanization: 'sa-sip-pal', english: '48' },
    { id: "Sino_Num_49", korean: '사십구', romanization: 'sa-sip-gu', english: '49' },
];

export const SINO_NUM_50_59 = [
    { id: "Sino_Num_50", korean: '오십', romanization: 'o-sip', english: '50' },
    { id: "Sino_Num_51", korean: '오십일', romanization: 'o-sip-il', english: '51' },
    { id: "Sino_Num_52", korean: '오십이', romanization: 'o-sip-i', english: '52' },
    { id: "Sino_Num_53", korean: '오십삼', romanization: 'o-sip-sam', english: '53' },
    { id: "Sino_Num_54", korean: '오십사', romanization: 'o-sip-sa', english: '54' },
    { id: "Sino_Num_55", korean: '오십오', romanization: 'o-sip-o', english: '55' },
    { id: "Sino_Num_56", korean: '오십육', romanization: 'o-sip-yuk', english: '56' },
    { id: "Sino_Num_57", korean: '오십칠', romanization: 'o-sip-chil', english: '57' },
    { id: "Sino_Num_58", korean: '오십팔', romanization: 'o-sip-pal', english: '58' },
    { id: "Sino_Num_59", korean: '오십구', romanization: 'o-sip-gu', english: '59' },
];

export const SINO_NUM_60_69 = [
    { id: "Sino_Num_60", korean: '육십', romanization: 'yuk-sip', english: '60' },
    { id: "Sino_Num_61", korean: '육십일', romanization: 'yuk-sip-il', english: '61' },
    { id: "Sino_Num_62", korean: '육십이', romanization: 'yuk-sip-i', english: '62' },
    { id: "Sino_Num_63", korean: '육십삼', romanization: 'yuk-sip-sam', english: '63' },
    { id: "Sino_Num_64", korean: '육십사', romanization: 'yuk-sip-sa', english: '64' },
    { id: "Sino_Num_65", korean: '육십오', romanization: 'yuk-sip-o', english: '65' },
    { id: "Sino_Num_66", korean: '육십육', romanization: 'yuk-sip-yuk', english: '66' },
    { id: "Sino_Num_67", korean: '육십칠', romanization: 'yuk-sip-chil', english: '67' },
    { id: "Sino_Num_68", korean: '육십팔', romanization: 'yuk-sip-pal', english: '68' },
    { id: "Sino_Num_69", korean: '육십구', romanization: 'yuk-sip-gu', english: '69' },
];

export const SINO_NUM_70_79 = [
    { id: "Sino_Num_70", korean: '칠십', romanization: 'chil-sip', english: '70' },
    { id: "Sino_Num_71", korean: '칠십일', romanization: 'chil-sip-il', english: '71' },
    { id: "Sino_Num_72", korean: '칠십이', romanization: 'chil-sip-i', english: '72' },
    { id: "Sino_Num_73", korean: '칠십삼', romanization: 'chil-sip-sam', english: '73' },
    { id: "Sino_Num_74", korean: '칠십사', romanization: 'chil-sip-sa', english: '74' },
    { id: "Sino_Num_75", korean: '칠십오', romanization: 'chil-sip-o', english: '75' },
    { id: "Sino_Num_76", korean: '칠십육', romanization: 'chil-sip-yuk', english: '76' },
    { id: "Sino_Num_77", korean: '칠십칠', romanization: 'chil-sip-chil', english: '77' },
    { id: "Sino_Num_78", korean: '칠십팔', romanization: 'chil-sip-pal', english: '78' },
    { id: "Sino_Num_79", korean: '칠십구', romanization: 'chil-sip-gu', english: '79' },
];

export const SINO_NUM_80_89 = [
    { id: "Sino_Num_80", korean: '팔십', romanization: 'pal-sip', english: '80' },
    { id: "Sino_Num_81", korean: '팔십일', romanization: 'pal-sip-il', english: '81' },
    { id: "Sino_Num_82", korean: '팔십이', romanization: 'pal-sip-i', english: '82' },
    { id: "Sino_Num_83", korean: '팔십삼', romanization: 'pal-sip-sam', english: '83' },
    { id: "Sino_Num_84", korean: '팔십사', romanization: 'pal-sip-sa', english: '84' },
    { id: "Sino_Num_85", korean: '팔십오', romanization: 'pal-sip-o', english: '85' },
    { id: "Sino_Num_86", korean: '팔십육', romanization: 'pal-sip-yuk', english: '86' },
    { id: "Sino_Num_87", korean: '팔십칠', romanization: 'pal-sip-chil', english: '87' },
    { id: "Sino_Num_88", korean: '팔십팔', romanization: 'pal-sip-pal', english: '88' },
    { id: "Sino_Num_89", korean: '팔십구', romanization: 'pal-sip-gu', english: '89' },
];

export const SINO_NUM_90_99 = [
    { id: "Sino_Num_90", korean: '구십', romanization: 'gu-sip', english: '90' },
    { id: "Sino_Num_91", korean: '구십일', romanization: 'gu-sip-il', english: '91' },
    { id: "Sino_Num_92", korean: '구십이', romanization: 'gu-sip-i', english: '92' },
    { id: "Sino_Num_93", korean: '구십삼', romanization: 'gu-sip-sam', english: '93' },
    { id: "Sino_Num_94", korean: '구십사', romanization: 'gu-sip-sa', english: '94' },
    { id: "Sino_Num_95", korean: '구십오', romanization: 'gu-sip-o', english: '95' },
    { id: "Sino_Num_96", korean: '구십육', romanization: 'gu-sip-yuk', english: '96' },
    { id: "Sino_Num_97", korean: '구십칠', romanization: 'gu-sip-chil', english: '97' },
    { id: "Sino_Num_98", korean: '구십팔', romanization: 'gu-sip-pal', english: '98' },
    { id: "Sino_Num_99", korean: '구십구', romanization: 'gu-sip-gu', english: '99' },
];

export const SINO_NUM_100_900 = [
    { id: "Sino_Num_100", korean: '백', romanization: 'baek', english: '100' },
    { id: "Sino_Num_101", korean: '백일', romanization: 'baek-il', english: '101' },
    { id: "Sino_Num_120", korean: '백이십', romanization: 'baek-i-sip', english: '120' },

    { id: "Sino_Num_200", korean: '이백', romanization: 'ibaek', english: '200' },
    { id: "Sino_Num_201", korean: '이백일', romanization: 'ibaek-il', english: '201' },
    { id: "Sino_Num_220", korean: '이백이십', romanization: 'ibaek-i-sip', english: '220' },

    { id: "Sino_Num_300", korean: '삼백', romanization: 'sambaek', english: '300' },
    { id: "Sino_Num_301", korean: '삼백일', romanization: 'sambaek-il', english: '301' },
    { id: "Sino_Num_320", korean: '삼백이십', romanization: 'sambaek-i-sip', english: '320' },

    { id: "Sino_Num_400", korean: '사백', romanization: 'sabaek', english: '400' },
    { id: "Sino_Num_401", korean: '사백일', romanization: 'sabaek-il', english: '401' },
    { id: "Sino_Num_420", korean: '사백이십', romanization: 'sabaek-i-sip', english: '420' },

    { id: "Sino_Num_500", korean: '오백', romanization: 'obaek', english: '500' },
    { id: "Sino_Num_501", korean: '오백일', romanization: 'obaek-il', english: '501' },
    { id: "Sino_Num_520", korean: '오백이십', romanization: 'obaek-i-sip', english: '520' },

    { id: "Sino_Num_600", korean: '육백', romanization: 'yukbaek', english: '600' },
    { id: "Sino_Num_601", korean: '육백일', romanization: 'yukbaek-il', english: '601' },
    { id: "Sino_Num_620", korean: '육백이십', romanization: 'yukbaek-i-sip', english: '620' },

    { id: "Sino_Num_700", korean: '칠백', romanization: 'chilbaek', english: '700' },
    { id: "Sino_Num_701", korean: '칠백일', romanization: 'chilbaek-il', english: '701' },
    { id: "Sino_Num_720", korean: '칠백이십', romanization: 'chilbaek-i-sip', english: '720' },

    { id: "Sino_Num_800", korean: '팔백', romanization: 'palbaek', english: '800' },
    { id: "Sino_Num_801", korean: '팔백일', romanization: 'palbaek-il', english: '801' },
    { id: "Sino_Num_820", korean: '팔백이십', romanization: 'palbaek-i-sip', english: '820' },

    { id: "Sino_Num_900", korean: '구백', romanization: 'gubaek', english: '900' },
    { id: "Sino_Num_901", korean: '구백일', romanization: 'gubaek-il', english: '901' },
    { id: "Sino_Num_920", korean: '구백이십', romanization: 'gubaek-i-sip', english: '920' },
];

export const SINO_NUM_1000_9000 = [
    { id: "Sino_Num_1000", korean: '천', romanization: 'cheon', english: '1000' },
    { id: "Sino_Num_2000", korean: '이천', romanization: 'icheon', english: '2000' },
    { id: "Sino_Num_3000", korean: '삼천', romanization: 'samcheon', english: '3000' },
    { id: "Sino_Num_4000", korean: '사천', romanization: 'sacheon', english: '4000' },
    { id: "Sino_Num_5000", korean: '오천', romanization: 'ocheon', english: '5000' },
    { id: "Sino_Num_6000", korean: '육천', romanization: 'yukcheon', english: '6000' },
    { id: "Sino_Num_7000", korean: '칠천', romanization: 'chilcheon', english: '7000' },
    { id: "Sino_Num_8000", korean: '팔천', romanization: 'palcheon', english: '8000' },
    { id: "Sino_Num_9000", korean: '구천', romanization: 'gucheon', english: '9000' },
];

export const SINO_NUM_10000_PLUS = [
    { id: "Sino_Num_10000", korean: '만', romanization: 'man', english: '10,000' },
    { id: "Sino_Num_20000", korean: '이만', romanization: 'iman', english: '20,000' },
    { id: "Sino_Num_30000", korean: '삼만', romanization: 'samman', english: '30,000' },
    { id: "Sino_Num_40000", korean: '사만', romanization: 'saman', english: '40,000' },
    { id: "Sino_Num_50000", korean: '오만', romanization: 'oman', english: '50,000' },
    { id: "Sino_Num_100000", korean: '십만', romanization: 'sipman', english: '100,000' },
    { id: "Sino_Num_200000", korean: '이십만', romanization: 'isipman', english: '200,000' },
    { id: "Sino_Num_500000", korean: '오십만', romanization: 'osipman', english: '500,000' },
    { id: "Sino_Num_1000000", korean: '백만', romanization: 'baekman', english: '1,000,000' },
    { id: "Sino_Num_2000000", korean: '이백만', romanization: 'ibaekman', english: '2,000,000' },
    { id: "Sino_Num_5000000", korean: '오백만', romanization: 'obaekman', english: '5,000,000' },
    { id: "Sino_Num_10000000", korean: '천만', romanization: 'cheonman', english: '10,000,000' },
    { id: "Sino_Num_50000000", korean: '오천만', romanization: 'ocheonman', english: '50,000,000' },
    { id: "Sino_Num_100000000", korean: '억', romanization: 'eok', english: '100,000,000' },
    { id: "Sino_Num_500000000", korean: '오억', romanization: 'oeok', english: '500,000,000' },
    { id: "Sino_Num_1000000000", korean: '십억', romanization: 'sibeok', english: '1,000,000,000' },
    { id: "Sino_Num_10000000000", korean: '백억', romanization: 'baekeok', english: '10,000,000,000' },
    { id: "Sino_Num_100000000000", korean: '천억', romanization: 'cheon-eok', english: '100,000,000,000' },
];
